module.exports = __webpack_public_path__ + "media/dynamicmaschines.f05e2bf9.mp4";